import React from 'react';
import PropTypes from 'prop-types';
import MaterialIcon from 'components/common/MaterialIcon';
import {Input, Select, Checkbox} from 'antd';
import uuidv1 from 'uuid/v1';

@autobind
/**
 *
 */
export default class Item extends React.PureComponent {
  static propTypes = {
    item: PropTypes.object,
    onChangeListItemInput: PropTypes.func,
    onChangeListItemSelect: PropTypes.func,
    onDeleteItem: PropTypes.func,
    option: PropTypes.bool,
    index: PropTypes.number,
  };
  static defaultProps = {
    item: {},
    option: true,
    index: 0,
  };

  /**
   *
   * @param {object} props
   */
  constructor(props) {
    super(props);
  }

  /**
   *
   */
  componentDidMount() {
  }

  _onDelete(e) {
    let that = this;
    let th = $(e.target).parent('li').attr('data-key');
    $(e.target).parent('li').slideUp(200, function () {
      that.props.onDeleteItem(th);
    });
  }


  /**
   *
   * @return {XML}
   */
  render() {
    const {item, index} = this.props;
    let _key = `${item.dataIndex}_${index}`;
    return (
      <li
        className="sortable_signatory"
        id={_key}
        data-id={index}
        data-key={item.dataKey ? item.dataKey : item.dataIndex}
      >
        <MaterialIcon name="close" size="tiny" onClick={(e) => this._onDelete(e)}/>
        <Input.Group compact>
          <MaterialIcon name="format-line-spacing" size="tiny"/>
          <Checkbox
            onChange={console.log}
            className='sortable_signatory_checkbox'
          >
              {item.name}
              <br/>
              {item.position}
          </Checkbox>
        </Input.Group>
      </li>
    );
  }
}
